module.exports = ""


//////////////////
// WEBPACK FOOTER
// E:/project/muyiwang/svn/project-code/trad-portal/src/app/scan-code/scan-code.component.html
// module id = ../../../../../src/app/scan-code/scan-code.component.html
// module chunks = main